// GetSVG.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const GetSVG = ({ url }) => {
  const [svgContent, setSvgContent] = useState(null);

  useEffect(() => {
    const fetchSVG = async () => {
      try {
        const response = await axios.get(url);
        if (response.status === 200) {
          const svgText = response.data;
          setSvgContent(svgText);
        } else {
          console.error('Error fetching SVG:', response.status);
        }
      } catch (error) {
        console.error('Error fetching SVG:', error);
      }
    };

    if (url) {
      fetchSVG();
    }
  }, [url]);

  return (
    <div
      className="svg-wrapper"
      dangerouslySetInnerHTML={{ __html: svgContent }}
    ></div>
  );
};

export default GetSVG;